module.exports = "pegasus/assets/blocks/column-lp8-basic.png";